import styled from 'styled-components'

export const StyledApplicationContainer = styled.div`
  max-width: ${props => props.theme.maxWidth};
  margin: auto;
  padding: 0 2rem 3rem;

  .application-subtext {
    display: block;
    color: ${props => props.theme.highlightColor};
    text-align: center;
    cursor: pointer;
  }

  @media only screen and (max-width: 600px) {
    padding: 0 0.8rem;
  }
`
